import { render, staticRenderFns } from "./GiftProduct.vue?vue&type=template&id=f65c32f4&scoped=true&lang=pug&"
import script from "./GiftProduct.vue?vue&type=script&lang=js&"
export * from "./GiftProduct.vue?vue&type=script&lang=js&"
import style0 from "./GiftProduct.vue?vue&type=style&index=0&id=f65c32f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../home/httpd/vhosts/tocin.com.tw/httpdocs/tocin-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f65c32f4",
  null
  
)

export default component.exports